import React from 'react';
import { useLocation } from 'react-router-dom'
import * as ROUTES  from '../../../../utils/constants/routes'
import Footer2 from '../footer-2';
const Footer = (props) => {
    const location = useLocation();
    if(location.pathname !== ROUTES.LANDING) return <Footer2/>
    return (
        <div>
            {/* <h3>This is the Footer</h3> */}
        </div>
    );
}

export default Footer;
